import React, { Component } from "react";

import BackHeader from "../../components/BackHeader";

import hartfordLogo from "../../images/carrierIcons/carrier_logo_hartford.png";
import libertyLogo from "../../images/carrierIcons/carrier_logo_liberty_mutual.png";
import travelersLogo from "../../images/carrierIcons/carrier_logo_travelers.png";
import cnaLogo from "../../images/carrierIcons/carrier_logo_cna.png";
import natLogo from "../../images/carrierIcons/carrier_logo_nat-general.png";
import uticaLogo from "../../images/carrierIcons/carrier_logo_utica.png";
import mainLogo from "../../images/carrierIcons/carrier_logo_main-street-america.png";
import cbicLogo from "../../images/carrierIcons/carrier_logo_cbic.png";
import progressiveLogo from "../../images/carrierIcons/carrier_logo_progressive.png";
import berkshireLogo from "../../images/carrierIcons/carrier_logo_berkshire.png";
import hiscoxLogo from "../../images/carrierIcons/carrier_logo_hiscox.png";

import "../../styles/premium-payment-info.scss";

class PaymentInfo extends Component {
  backToMenu() {
    this.props.history.goBack();
  }

  render() {
    return (
      <div id="reference-tools">
        <BackHeader text="Reference Tools" onClick={() => this.backToMenu()} />
        <h1 className="payment-info-header">Premium Payment Info</h1>

        <div className="payment-info-table">
          <div className="payment-info-table-header">
            <div className="table-row">
              <div className="first-column">Carrier</div>
              <div className="second-column">Billing</div>
              <div className="third-column">Payment Plans</div>
            </div>
          </div>

          <div className="payment-info-table-body">
            <Carrier
              name="Berkshire Hathaway"
              logo={berkshireLogo}
              logoWidth={115}
              billing={<BillingPhone phone="877-680-2442" />}
              payment={
                <>
                  <p>
                    Refer to the Berkshire proposal for payment options offered.
                  </p>
                  <p>**They accept EFT, Visa, AMEX, Discover and Mastercard.</p>
                </>
              }
            />
            <Carrier
              name="CBIC/RLI"
              logo={cbicLogo}
              logoWidth={115}
              billing={<BillingPhonePlusCAandWA phone="888-825-2242" />}
              payment={
                <>
                  <p>
                    Premium size $0 to $500 should be paid in full. $501 and
                    over- 25% down plus 9 installments.
                  </p>
                  <p>
                    CBIC accepts credit card (VISA, Master, Discover & Amex)
                    only for down payment. Please note: Discover and Amex are
                    not accepted in the states of CA and WA.
                  </p>
                  <p>
                    EFT as a down payment cannot be accepted, but future
                    payments can be set up on EFT by the insured, when insured
                    elects to set up re-occurring payment directly with CBIC.
                    Directions will be listed on their first bill.
                  </p>
                </>
              }
            />
            <Carrier
              name="C.N.A"
              logo={cnaLogo}
              logoWidth={115}
              billing={
                <>
                  <BillingPhone phone="800-742-9705" />
                  <p>
                    <strong>Mail check to:</strong>
                    <br />
                    C.N.A Insurance Company
                    <br />
                    Lockbox 790094
                    <br />
                    St. Louis, MO 63179
                  </p>
                </>
              }
              payment={
                <>
                  <p>Refer to C.N.A proposal for payment options offered.</p>
                  <p>
                    **They accept credit cards (Visa, Master, Discover and
                    Amax), Check or EFT payments.
                  </p>
                </>
              }
            />
            <Carrier
              name="Hartford"
              logo={hartfordLogo}
              logoWidth={115}
              billing={
                <>
                  <BillingPhone phone="800-375-0506" />
                  <p>
                    <strong>Checks made payable to:</strong> The Hartford
                  </p>
                  <p>
                    <strong>Mail check to:</strong>
                    <br />
                    The Hartford
                    <br />
                    PO Box 660916
                    <br />
                    Dallas, TX 75266-0916
                  </p>
                  <p>
                    <strong>Overnight check to:</strong>
                    <br />
                    REMITCO – The Hartford #916
                    <br />
                    1010 W. Mockingbird Ln, Ste. 100
                    <br />
                    Dallas, TX 75247
                  </p>
                </>
              }
              payment={
                <>
                  <p>
                    Refer to Hartford’s Proposal for payment options offered.
                  </p>
                  <p>**Accepts all credit cards, check and EFT payments.</p>
                </>
              }
            />
            <Carrier
              name="Hiscox"
              logo={hiscoxLogo}
              logoWidth={115}
              billing={<BillingPhone phone="855-870-9327" />}
              payment={
                <p>
                  <strong>
                    **Credit card payment only, ALWAYS set up on re-occurring
                    payments on the card used for down payment at binding.
                    Accepts Visa, Mastercard and AMEX.
                  </strong>
                </p>
              }
            />
            <Carrier
              name="Liberty Mutual Insurance Company"
              logo={libertyLogo}
              logoWidth={115}
              billing={
                <>
                  <BillingPhone phone="866-290-2920" />
                  <table className="billing-table">
                    <tbody>
                      <tr>
                        <th>State</th>
                        <th>Installment Fee</th>
                        <th>Recurring Credit/Debit Card Fee</th>
                        <th>Recurring Electronic Check Fee</th>
                      </tr>
                      <tr>
                        <th>
                          AL, AK, AZ, AR, CO, CT, DE, DC, GA, ID, IL, IN, IA,
                          KS, KY, LA, ME, MD, MA, MI, MN, MS, MO, MT, NE, NH,
                          NJ, NY, ND, OK, OR, PA, RI, SC, SD, TN, TX, UT, VA,
                          WA, WI, WY
                        </th>
                        <td>$8.00</td>
                        <td>$8.00</td>
                        <td>$5.00</td>
                      </tr>
                      <tr>
                        <th>CA</th>
                        <td>$10.00</td>
                        <td>$10.00</td>
                        <td>No Fee</td>
                      </tr>
                      <tr>
                        <th>FL</th>
                        <td>$3.00</td>
                        <td>$3.00</td>
                        <td>$1.00</td>
                      </tr>
                      <tr>
                        <th>NV</th>
                        <td>$8.00</td>
                        <td>$8.00</td>
                        <td>No Fee</td>
                      </tr>
                      <tr>
                        <th>NM</th>
                        <td>$7.00</td>
                        <td>$7.00</td>
                        <td>$5.00</td>
                      </tr>
                      <tr>
                        <th>NC</th>
                        <td>$7.00</td>
                        <td>$7.00</td>
                        <td>$3.00</td>
                      </tr>
                      <tr>
                        <th>OH, VT</th>
                        <td>$6.00</td>
                        <td>$6.00</td>
                        <td>$5.00</td>
                      </tr>
                      <tr>
                        <th>WV</th>
                        <td>$5.00</td>
                        <td>$5.00</td>
                        <td>$3.00</td>
                      </tr>
                    </tbody>
                  </table>
                </>
              }
              payment={
                <>
                  <p>
                    Automatic Payments Using EFT or Credit/Debit Card only
                    (service fees apply):
                  </p>
                  <ul>
                    <li>Full-pay — 100% down</li>
                    <li>
                      Quarterly — 25% down, 3 equal installments at 90-day
                      intervals
                    </li>
                  </ul>
                  <p>Monthly Option:</p>
                  <ul>
                    <li>
                      Any Policy/Account &lt; $25,000 requires 2 months down, 10
                      equal installments
                    </li>
                    <li>
                      Any Policy/Account &gt; $25,001 requires 1 month down, 11
                      equal monthly installments
                    </li>
                  </ul>
                  <p>
                    <b>
                      Automatic payment plans are the only options that should
                      be given to the insured.
                    </b>
                  </p>
                  <p>
                    <b style={{ color: "red" }}>Important: </b>
                    Beginning of July 2024, all customer credit card payments
                    will incur a 2.5% fee.
                  </p>
                  <ul>
                    <li>
                      No payment service fees assessed to those who pay via ACH.
                    </li>
                    <li>Billing service charges and fees vary by state.</li>
                    <li>
                      The installment fee and processing fee will be applied to
                      recurring CC and only the installment fee (flat $ amount)
                      will be applied to EFT.
                    </li>
                    <li>
                      <b style={{ color: "red" }}>
                        The 2.5% surcharge will be calculated on the amount due
                        at the time of processing and will be in addition to any
                        installment fees. For example:
                      </b>
                      <ul>
                        <li>
                          Down payment will be 2.5% of the down payment amount.
                        </li>
                        <li>
                          Future installments will charge 2.5% of the
                          installment amount.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </>
              }
            />
            <Carrier
              name="Main Street America"
              logo={mainLogo}
              logoWidth={115}
              billing={
                <>
                  <BillingPhone phone="866-676-3849" />
                  <p>
                    <strong>Checks made payable to:</strong> NGM
                  </p>
                  <p>
                    <strong>Mail check to:</strong>
                    <br />
                    Main Street American Group
                    <br />
                    PO BOX 981409
                    <br />
                    Boston, MA 02298-1409
                  </p>
                  <p>
                    <strong>Overnight check to:</strong>
                    <br />
                    Attn: Premium Services
                    <br />
                    55 West Street
                    <br />
                    Keene, NH 03431-3373
                  </p>
                </>
              }
              payment={
                <>
                  <p>Refer to MSA proposal for payment options offered.</p>
                  <p>
                    **Accepts EFT, Check and all credit cards with exception of
                    AMEX (does <strong>not</strong> accept American Express)
                  </p>
                </>
              }
            />
            <Carrier
              name="National General"
              logo={natLogo}
              logoWidth={115}
              billing={
                <>
                  <p>
                    <strong>Billing &mdash;</strong> 844-582-7973 or
                    877-468-3466
                  </p>
                  <p>
                    For automated payments please visit:{" "}
                    <a href="https://www.mynatgenpolicy.com">
                      www.MyNatGenPolicy.com
                    </a>
                  </p>
                </>
              }
              payment={
                <>
                  <p>
                    Refer to National General proposal for payment options
                    offered.
                  </p>
                  <p>**They accept EFT, Visa, Mastercard, AMEX and Discover</p>
                </>
              }
            />
            <Carrier
              name="Progressive"
              logo={progressiveLogo}
              logoWidth={115}
              billing={
                <>
                  <BillingPhone phone="800-876-7206" />
                </>
              }
              payment={
                <>
                  <p>
                    Refer to Progressive
                    proposal for payment options offered.
                  </p>
                  <p>
                    **Accepts EFT and Credit card payments. Accepts Visa,
                    Mastercard and Discover only.
                    <br />
                    <strong>(does not accept American Express)</strong>
                  </p>
                </>
              }
            />
            <Carrier
              name="Travelers"
              logo={travelersLogo}
              logoWidth={115}
              billing={
                <>
                  <BillingPhone phone="800-252-2268" />
                  <p>
                    <strong>Checks made payable to:</strong>
                    <br />
                    Travelers
                  </p>
                  <p>
                    <strong>Mail checks to:</strong>
                    <br />
                    Travelers
                    <br />
                    PO BOX 660317
                    <br />
                    Dallas, TX 75266-0317
                  </p>
                  <p>
                    <strong>Overnight checks to:</strong>
                    <br />
                    Travelers
                    <br />
                    Attn: Cash Team
                    <br />
                    9954 Mayland Drive, Ste 6100
                    <br />
                    Richmond, VA 23233
                  </p>
                </>
              }
              payment={
                <>
                  <p>
                    <strong>Available Payment Plans</strong>: Depending on the state, installment fees range from $5 to $6 per installment. Travelers accepts credit cards (Amex, Visa & MasterCard), and EFT. *For EFT payments, please ensure you keep the completed and signed EFT form for your records.
                  </p>
                  <p>
                    <li>Lump Sum, balance due on the first invoice</li>
                    <li>2 Pay (50% down and 1 remaining), paid in full 6 months prior to expiration date (semi-annual billing)</li>
                    <li>4 Pay (25% down and 3 remaining), paid in full 2 months prior to expiration date (quarterly billing)</li>
                    <li>6 Pay (25% down and 5 remaining or 20% down and 5 remaining in Texas), paid in full 6 months prior to expiration date (monthly billing)</li>
                    <li>10 Pay (25% down and 9 remaining or 20% down and 9 remaining in Texas), paid in full 2 months prior to expiration date (monthly billing)</li>
                    <li>10 Equal installments, paid in full 2 months prior to expiration date (monthly billing)</li>
                    <li>12 Equal installments with mandatory automatic recurring payments (not available for all business units)</li>
                  </p>
                </>
              }
            />
            <Carrier
              name="Utica First"
              logo={uticaLogo}
              logoWidth={115}
              billing={
                <>
                  <BillingPhone phone="800-456-4556" />

                  <p>
                    <strong>Checks payable to:</strong>
                    <br />
                    Utica First Insurance
                  </p>

                  <p>
                    <strong>Mail Checks to:</strong>
                    <br />
                    Utica First Insurance
                    <br />
                    PO Box 851
                    <br />
                    Utica First, NY 13503
                  </p>
                </>
              }
              payment={
                <>
                  <p>
                    <strong>Premium Size up to $500</strong> = Full Pay
                  </p>

                  <p>
                    <strong>
                      Premium Size $501 and up = Quarterly (4-Pay)
                    </strong>{" "}
                    &mdash; 30% down or $150 (whichever is greater) at time of
                    binding, payments to follow every 60 days (Artisans) or 75
                    days (All other commercial lines).
                  </p>

                  <p>
                    <strong>Monthly =</strong> 30% down or $150 (whichever is
                    greater) at time of binding (EFT Only); payments then
                    automatically deducted monthly on the same day as the policy
                    effective day.
                  </p>

                  <p>**Accepts EFT, Check and All credit cards</p>
                </>
              }
            />
            <br />
            <br />
            <div className="table-row">
              <p className="additional-fees">
                <strong>
                  Please note that there may be additional fees that may be due
                  and are charged by the carrier. Those fees vary by carrier and
                  state and Ivantage is not responsible for the calculation of
                  those fees. If you have questions regarding the fees that are
                  being added please reach out to the carrier for specific
                  information.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentInfo;

function Carrier({ name, logo, billing, payment, logoWidth = 100 }) {
  return (
    <div className="table-row">
      <div className="first-column carrier-name">
        <span className="carrier-name">{name}</span>
        <img src={logo} alt="logo" style={{ width: logoWidth }} />
      </div>
      <div className="second-column">{billing}</div>
      <div className="third-column">{payment}</div>
    </div>
  );
}

function BillingPhone({ phone }) {
  return (
    <p>
      <strong>Billing&mdash;</strong> <a href={"tel:" + phone}>{phone}</a>
    </p>
  );
}

function BillingPhonePlusCAandWA({ phone }) {
  return (
    <p>
      <strong>Billing&mdash;</strong> <a href={"tel:" + phone}>{phone}</a> CA
      and WA
      <br /> <br />
      Billing Number for policy prefix CKA (all states except for CA and WA) is
      <a href="tel: 866-216-8099"> 866-216-8099</a>
    </p>
  );
}
